import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createModelAttachmentFailed,
  createModelAttachmentRequested,
  createModelAttachmentSucceeded,
  deleteModelAttachmentFailed,
  deleteModelAttachmentRequested,
  deleteModelAttachmentSucceeded,
  updateModelAttachmentFailed,
  updateModelAttachmentRequested,
  updateModelAttachmentSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createModelAttachmentRequest(modelId, localId, data) {
  yield put(
    createModelAttachmentRequested(localId, {
      ...data,
      modelId,
    }),
  );

  try {
    const { item } = yield call(request, api.createModelAttachment, modelId, data, localId);

    const action = createModelAttachmentSucceeded(localId, item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createModelAttachmentFailed(localId, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateModelAttachmentRequest(id, data) {
  yield put(updateModelAttachmentRequested(id, data));

  try {
    const { item } = yield call(request, api.updateModelAttachment, id, data);

    const action = updateModelAttachmentSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateModelAttachmentFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteModelAttachmentRequest(id) {
  yield put(deleteModelAttachmentRequested(id));

  try {
    const { item } = yield call(request, api.deleteModelAttachment, id);

    const action = deleteModelAttachmentSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteModelAttachmentFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
